import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import Switch from "@hl/communities-app/src/components/Switch";
import { Box, Button, Modal, Text, Group } from "@mantine/core";
import { useForm } from "@mantine/form";

import { useUpdateCollectionOffChainMutation } from "~/features/tokens/sections/ManageToken/queries.graphql.generated";

/* eslint-disable  @typescript-eslint/no-explicit-any */
type Props = {
  hidden?: boolean | null;
  collectionId: string;
  isOpened: boolean;
  onClose: () => void;
  refetch?: () => void;
};

interface EditDetailsFormValues {
  showCollection: boolean;
}

export const EditHideCollection = ({
  isOpened,
  onClose,
  collectionId,
  hidden,
  refetch,
}: Props) => {
  const closeModal = () => {
    refetch?.();
    form.reset();
    onClose();
  };

  const [updateCollectionOffChain, { loading, error }] =
    useUpdateCollectionOffChainMutation({
      onCompleted: closeModal,
    });
  const form = useForm<EditDetailsFormValues>({
    initialValues: {
      showCollection: !hidden,
    },
  });

  const onSubmit = form.onSubmit((values) =>
    updateCollectionOffChain({
      variables: {
        collectionId: collectionId,
        data: {
          hidden: !values.showCollection,
        },
      },
    })
  );

  return (
    <Modal
      size="lg"
      opened={isOpened}
      onClose={() => {
        form.reset();
        onClose();
      }}
      title="Profile options"
    >
      <Box mx="auto">
        <form onSubmit={onSubmit}>
          <Group position="apart" align="center">
            <Text size="sm">Include collection in profile</Text>
            <Switch
              {...form.getInputProps("showCollection")}
              checked={form.getInputProps("showCollection").value}
            />
          </Group>
          <ModalSection>
            <Button type="submit" size="xl" fullWidth loading={loading}>
              Save changes
            </Button>
            {error && (
              <Text size="xs" mt={5} color={STATUS_COLOR.ERROR}>
                Error saving changes
              </Text>
            )}
          </ModalSection>
        </form>
      </Box>
    </Modal>
  );
};
